import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from 'recharts';
import { stackedChartData, stackedCustomSeries } from './data';
import { useStateContext } from '../../contexts/ContextProvider';

interface StackedInterface {
  width?: any;
  height?: any;
}

const Stacked = ({ width = '100%', height = 300 }: StackedInterface) => {
  const { currentMode } = useStateContext();

  // Combine stackedChartData arrays into a single data array with keys per series name
  const seriesNames = stackedCustomSeries.map((s: any) => s.name || `series${Math.random()}`);
  const combined: any[] = [];

  // assume each series has same length and matching x values
  if (stackedChartData && stackedChartData.length > 0) {
    const len = stackedChartData[0].length;
    for (let i = 0; i < len; i++) {
      const entry: any = { x: stackedChartData[0][i].x };
      stackedChartData.forEach((seriesArr: any[], si: number) => {
        const key = seriesNames[si] || `series${si}`;
        entry[key] = seriesArr[i] ? seriesArr[i].y : 0;
      });
      combined.push(entry);
    }
  }

  const colors = ['#8884d8', '#82ca9d', '#ffc658', '#ff8042'];

  return (
    <div style={{ width, height, background: currentMode === 'Dark' ? '#33373E' : '#fff', padding: 8, borderRadius: 6 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={combined}>
          <CartesianGrid strokeDasharray="3 3" stroke={currentMode === 'Dark' ? '#444' : '#e6e6e6'} />
          <XAxis dataKey="x" tick={{ fill: currentMode === 'Dark' ? '#d1d5db' : '#374151' }} />
          <YAxis tick={{ fill: currentMode === 'Dark' ? '#d1d5db' : '#374151' }} />
          <Tooltip contentStyle={{ backgroundColor: currentMode === 'Dark' ? '#1f2937' : '#fff', borderRadius: 6 }} />
          <Legend wrapperStyle={{ color: currentMode === 'Dark' ? '#eee' : '#333' }} />
          {seriesNames.map((name: string, idx: number) => (
            <Bar key={name} dataKey={name} stackId="a" fill={colors[idx % colors.length]} />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Stacked;
